(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-counter"] && !Shopify.designMode) return;
  try {
    
  class CounterStat extends HTMLElement {
    connectedCallback() {
      this.valueEl = this.querySelector('[data-counter-value]');
      this.target = parseFloat(this.dataset.target) || 0;
      this.duration = (parseFloat(this.dataset.duration) || 2) * 1000;
      this.once = this.dataset.once !== 'false';
      this.decimals = (this.dataset.target.split('.')[1] || '').length;
      this.hasAnimated = false;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && (!this.hasAnimated || !this.once)) {
              this.animate();
              this.hasAnimated = true;
            }
          });
        },
        { threshold: 0.4 }
      );

      this.observer.observe(this);
    }

    animate() {
      const start = performance.now();
      const from = 0;
      const to = this.target;

      const step = (now) => {
        const progress = Math.min((now - start) / this.duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = from + (to - from) * eased;
        this.valueEl.textContent = current.toFixed(this.decimals);

        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          this.valueEl.textContent = to.toFixed(this.decimals);
        }
      };

      requestAnimationFrame(step);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('counter-stat')) {
    customElements.define('counter-stat', CounterStat);
  }

  } catch(e) { console.error(e); }
})();
})();
